import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { GROUP_STATUSES, type GroupStatus } from "../../types";
import { useUiStore } from "../../store/uiStore";
import { StatusPill } from "../Pills";

function isGroupStatus(value: string | undefined): value is GroupStatus {
  return value !== undefined && (GROUP_STATUSES as readonly string[]).includes(value);
}

/** `Recent Groups > Group > Member` bar shown once inside a group. */
export function Breadcrumb() {
  const entries = useUiStore((state) => state.breadcrumb);

  if (entries.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="border-b border-gray-200 bg-white">
      <ol className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-1 px-6 py-2 text-sm">
        {entries.map((entry, index) => {
          const isLast = index === entries.length - 1;
          return (
            <li key={`${entry.to}-${index}`} className="flex items-center gap-1">
              {index > 0 && <ChevronRight size={14} className="text-gray-400" aria-hidden="true" />}
              {isLast ? (
                <span aria-current="page" className="font-medium text-brand-navy">
                  {entry.label}
                </span>
              ) : (
                <Link to={entry.to} className="text-gray-600 hover:text-brand-navy hover:underline focus:outline-none focus:ring-2 focus:ring-brand-green-50 rounded">
                  {entry.label}
                </Link>
              )}
              {isGroupStatus(entry.status) && (
                <span className="ml-1">
                  <StatusPill status={entry.status} />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
